import { render, staticRenderFns } from "./Paginacion.vue?vue&type=template&id=74dafa06&scoped=true&"
import script from "./Paginacion.vue?vue&type=script&lang=js&"
export * from "./Paginacion.vue?vue&type=script&lang=js&"
import style0 from "./Paginacion.vue?vue&type=style&index=0&id=74dafa06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74dafa06",
  null
  
)

export default component.exports